import { render } from "./DebriyajMerkezi.vue?vue&type=template&id=bf5143de"
import script from "./DebriyajMerkezi.vue?vue&type=script&lang=js"
export * from "./DebriyajMerkezi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__